// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInPagesAuthorizeMfaCodeMutationVariables = Types.Exact<{
  mfaCode: Types.Scalars['String']['input'];
}>;


export type SignInPagesAuthorizeMfaCodeMutation = { __typename?: 'Mutation', authorizeMfaCode: boolean };


export const SignInPagesAuthorizeMfaCodeDocument = gql`
    mutation signInPagesAuthorizeMfaCode($mfaCode: String!) {
  authorizeMfaCode(mfaCode: $mfaCode)
}
    `;
export type SignInPagesAuthorizeMfaCodeMutationFn = Apollo.MutationFunction<SignInPagesAuthorizeMfaCodeMutation, SignInPagesAuthorizeMfaCodeMutationVariables>;

/**
 * __useSignInPagesAuthorizeMfaCodeMutation__
 *
 * To run a mutation, you first call `useSignInPagesAuthorizeMfaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInPagesAuthorizeMfaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInPagesAuthorizeMfaCodeMutation, { data, loading, error }] = useSignInPagesAuthorizeMfaCodeMutation({
 *   variables: {
 *      mfaCode: // value for 'mfaCode'
 *   },
 * });
 */
export function useSignInPagesAuthorizeMfaCodeMutation(baseOptions?: Apollo.MutationHookOptions<SignInPagesAuthorizeMfaCodeMutation, SignInPagesAuthorizeMfaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInPagesAuthorizeMfaCodeMutation, SignInPagesAuthorizeMfaCodeMutationVariables>(SignInPagesAuthorizeMfaCodeDocument, options);
      }
export type SignInPagesAuthorizeMfaCodeMutationHookResult = ReturnType<typeof useSignInPagesAuthorizeMfaCodeMutation>;
export type SignInPagesAuthorizeMfaCodeMutationResult = Apollo.MutationResult<SignInPagesAuthorizeMfaCodeMutation>;
export type SignInPagesAuthorizeMfaCodeMutationOptions = Apollo.BaseMutationOptions<SignInPagesAuthorizeMfaCodeMutation, SignInPagesAuthorizeMfaCodeMutationVariables>;